module.exports = __webpack_public_path__ + "files/0d367a00a16bde58f7e87c4481516a68.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/android-chrome-192x192.png
// module id = 725
// module chunks = 59